import * as React from 'react';

import { cn } from '@/lib/shadcn/utils';

type CalloutVariant = 'info' | 'success' | 'warning';

const variantStyles: Record<CalloutVariant, string> = {
  // Use exact left-border colors matching legacy design
  info: '[border-left:3px_solid_var(--primary)]',
  success: '[border-left:3px_solid_#52c41a]',
  warning: '[border-left:3px_solid_#faad14]',
};

function Callout({
  className,
  variant = 'info',
  ...props
}: React.ComponentProps<'div'> & { variant?: CalloutVariant }) {
  return (
    <div className={cn('pl-3', variantStyles[variant], className)} {...props} />
  );
}

function CalloutTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('font-semibold', className)} {...props} />;
}

function CalloutDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div className={cn('text-sm text-neutral-600', className)} {...props} />
  );
}

export { Callout, CalloutDescription, CalloutTitle };
